// @flow

import type {
  StringsResponse,
  OperatorSettingsResponse,
  WhitelabelAppSettingsResponse,
} from './types-settings';
import { api } from './fetch';

// prettier-ignore
export const getStrings
  : () => Promise<StringsResponse>
  = (locale: string = navigator.language) =>
    api('getstrings', {
      query: {
        locale,
        system: 'Fleet',
      },
    });

// prettier-ignore
export const getOperatorSettings
  : () => Promise<OperatorSettingsResponse>
  = () => api('getoperatorsettings');

// prettier-ignore
export const getWhitelabelAppSettings
  : () => Promise<WhitelabelAppSettingsResponse>
  = () => api('getwhitelabelappsettings');



// WEBPACK FOOTER //
// ./src/api/settings.js